export const GET_MANUFACTURER_REQUEST = "GET_MANUFACTURER_REQUEST";
export const GET_MANUFACTURER_SUCCESS = "GET_MANUFACTURER_SUCCESS";
export const GET_MANUFACTURER_FAILURE = "GET_MANUFACTURER_FAILURE";

export const DELETE_MANUFACTURER_REQUEST = "DELETE_MANUFACTURER_REQUEST";
export const DELETE_MANUFACTURER_SUCCESS = "DELETE_MANUFACTURER_SUCCESS";
export const DELETE_MANUFACTURER_FAILURE = "DELETE_MANUFACTURER_FAILURE";

export const CREATE_MANUFACTURER_REQUEST = "CREATE_MANUFACTURER_REQUEST";
export const CREATE_MANUFACTURER_SUCCESS = "CREATE_MANUFACTURER_SUCCESS";
export const CREATE_MANUFACTURER_FAILURE = "CREATE_MANUFACTURER_FAILURE";

export const EDIT_MANUFACTURER_REQUEST = "EDIT_MANUFACTURER_REQUEST";
export const EDIT_MANUFACTURER_SUCCESS = "EDIT_MANUFACTURER_SUCCESS";
export const EDIT_MANUFACTURER_FAILURE = "EDIT_MANUFACTURER_FAILURE";


export const UPLOADCSV_MANUFACTURER_REQUEST = "UPLOADCSV_MANUFACTURER_REQUEST";
export const UPLOADCSV_MANUFACTURER_SUCCESS = "UPLOADCSV_MANUFACTURER_SUCCESS";
export const UPLOADCSV_MANUFACTURER_FAILURE = "UPLOADCSV_MANUFACTURER_FAILURE";